import { getCurrentUserInfo } from "./getCurrentUserInfo";
import { getFollowing, getFollowingActivities } from "./getFollowerData";

const docLimit = 5;

export const getInitialFeedData = async () => {
  const docStart = 0;
  const docEnd = docLimit;

  const currentUser = await getCurrentUserInfo();
  const followingUser = await getFollowing(currentUser.id);
  const { activityDocs, lastIndex, noNextData } = await getFollowingActivities(
    followingUser,
    docStart,
    docEnd,
    currentUser
  );

  return { workoutsPerDay: activityDocs, lastIndex, currentUser, followingUser, noNextData };
};

export const getNextFeedData = async (lastFeedData) => {
  const { lastIndex: oldLastIndex, followingUser, currentUser } = lastFeedData;
  const docStart = oldLastIndex;
  const docEnd = oldLastIndex + docLimit;

  const { activityDocs, lastIndex, noNextData } = await getFollowingActivities(
    followingUser,
    docStart,
    docEnd,
    currentUser
  );

  return { workoutsPerDay: activityDocs, lastIndex, noNextData };
};
